<template>
  <div v-if="payments.length > 0" class="col-sm-12 auctions__list employee-payments">
    <div class="employee__filtration">
      <div v-if="meta" class="col">
        <Pagination class="text-center" :meta="meta" showInputGap />
      </div>
    </div>
    <PaymentsList
      :auctionsCatalogs="payments"
      :meta="meta"
    />
    <div class="employee__filtration">
      <div v-if="meta" class="col">
        <Pagination class="text-center" scrollPageToUp :meta="meta" showInputGap />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Pagination from '@/shared/components/pagination/index';
  import PaymentsList from './auctions_catalogs/list';

  export default {
    name: 'Payments',
    components: {
      PaymentsList,
      Pagination,
    },
    created() {
      this.getPayments(this.currentPage);
    },
    watch: {
      currentPage() {
        this.getPayments(this.currentPage);
      },
    },
    computed: {
      ...mapGetters('auctionsCatalogs', ['payments', 'meta']),
      currentPage() {
        return {
          page: this.$route.query.page,
        };
      },
    },
    methods: {
      ...mapActions('auctionsCatalogs', ['getPayments']),
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/payments/index.vue?5ab9885e